export default "__VITE_ASSET__CH0yJEw2__"